var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { Animate } from "../Animate";
var TabBlock = /** @class */ (function (_super) {
    __extends(TabBlock, _super);
    function TabBlock(props) {
        var _this = _super.call(this, props) || this;
        _this.hide = {
            animation: { opacity: 0 },
            duration: 150,
            easing: "ease"
        };
        _this.show = __assign({}, _this.hide, { animation: { opacity: 1 }, duration: 350 });
        _this.state = { anim: __assign({}, _this.hide) };
        _this.block = null;
        return _this;
    }
    TabBlock.prototype.hideBlock = function () { this.setState({ anim: __assign({}, this.hide) }); };
    TabBlock.prototype.showBlock = function () { this.setState({ anim: __assign({}, this.show) }); };
    TabBlock.prototype.componentDidMount = function () {
        if (this.block) {
            this.block["show"] = this.showBlock.bind(this);
            this.block["hide"] = this.hideBlock.bind(this);
        }
    };
    TabBlock.prototype.render = function () {
        var _this = this;
        return (React.createElement(Animate, __assign({}, this.state.anim),
            React.createElement("sb-tabs-block", { "data-tab-block": true, ref: function (n) { return _this.block = n; }, "data-tab-link": this.props.link },
                React.createElement("sb-tabs-content", { "data-tab-content": true }, this.props.children))));
    };
    return TabBlock;
}(React.Component));
export { TabBlock };
//# sourceMappingURL=TabBlock.js.map